const contactDetailsStyle = () => ({
	workingNumber: {
		paddingLeft: 42,
	},
});

export default contactDetailsStyle;
